//@flow
//Action Type Registered
export const RHEA_INV_SUBMIT_SUCCESS='RHEA_INV_SUBMIT_SUCCESS'
export const RHEA_INV_SUBMIT_ERROR='RHEA_INV_SUBMIT_ERROR'
export const RHEA_INV_SUBMITTED_COMPLETED='RHEA_INV_SUBMITTED_COMPLETED'
export const RHEA_EDIT_VERIFY_FORM_DATA_SUCCESS='RHEA_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const RHEA_EDIT_VERIFY_FORM_DATA_ERROR='RHEA_EDIT_VERIFY_FORM_DATA_ERROR'
export const RHEA_UPDATE_FORM_ERROR='RHEA_UPDATE_FORM_ERROR'
export const REFRESH_RHEA_VENDORS_SUCCESS='REFRESH_RHEA_VENDORS_SUCCESS'
export const REFRESH_RHEA_VENDORS_ERROR='REFRESH_RHEA_VENDORS_ERROR'
export const REFRESH_RHEA_REQUESTORS_SUCCESS='REFRESH_RHEA_REQUESTORS_SUCCESS'
export const REFRESH_RHEA_REQUESTORS_ERROR='REFRESH_RHEA_REQUESTORS_ERROR'
export const REFRESH_RHEA_CACHE_VALUE='REFRESH_RHEA_CACHE_VALUE'


// WEBPACK FOOTER //
// ./src/redux/rhea/actionTypes.js